import * as R from 'ramda';

export default function SyncAssetTypeDialogController(
  $q,
  $rootScope,
  $scope,
  ssDialogService,
  confirmDialog,
  alerts,
  assetDataService,
  loaderService, // eslint-disable-line no-unused-vars
  syncAssetConfirmDialog,
  assetSharedModelService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSyncAssets = _handleSyncAssets;
  vm.handleCheckAllChange = _handleCheckAllChange;
  vm.isEditable = true;
  vm.handleClearFilters = _handleClearFilters;
  vm.showFilters = true;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    vm.searchText = '';
    vm.assets = [];
    if (vm.assetType.customerAssets && vm.assetType.customerAssets.length > 0) {
      angular.forEach(vm.assetType.customerAssets, (asset) => {
        if (!asset.isSynced) {
          vm.assets.push(angular.copy(asset));
        }
      });
    }

    $scope.$on('refreshSyncAssets', (event, opt) => {
      if (opt.assetType.customerAssetTypeId === vm.assetType.customerAssetTypeId) {
        loaderService.showViewLoader = true;
        _getAssetTypeWithInstances();
      }
    });
    $scope.$on('selectSyncAssetChange', () => {
      _handleSyncAssetChange();
    });
    vm.filteredAssets = vm.assets;
  }

  function _handleSyncAssetChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isSyncSelected === true) {
        selectedIds.push(item.customerAssetId);
      }
    }, vm.assets);
    vm.selectAll = selectedIds.length === vm.assets.length;
  }

  function _handleClearFilters() {
    vm.searchText = '';
  }

  function _handleCheckAllChange() {
    R.forEach(
      (asset) => {
        asset.isSyncSelected = vm.selectAll;
      },
      vm.assets
    );
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleSyncAssets($event) {
    const _assets = [];
    R.forEach(
      (asset) => {
        if (asset.isSyncSelected === true) {
          _assets.push(asset);
        }
      },
      vm.assets
    );
    if (_assets.length > 0) {
      ssDialogService.dialogs.assetAdmin.syncAssetDialog = ssDialogService.alert(
        syncAssetConfirmDialog.getOptions($event, {
          assets: _assets,
          assetType: vm.assetType,
          isMultipleAssets: true,
          updateCallBack: _broadcastEvents,
        })
      );

      ssDialogService.show(ssDialogService.dialogs.assetAdmin.syncAssetDialog);
    }
  }

  function _broadcastEvents() {
    $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.syncAssetTypeDialog);
  }

  function _getAssetTypeWithInstances() {
    assetDataService.getAssetTypeWithInstances(vm.assetType.customerAssetTypeId)
      .then((getAssetTypeResponse) => {
        Object.assign(vm.assetType, getAssetTypeResponse.data);
        _initCriticalityForAssets(vm.assetType.customerAssets);
        vm.assets = [];
        if (vm.assetType.customerAssets && vm.assetType.customerAssets.length > 0) {
          angular.forEach(vm.assetType.customerAssets, (asset) => {
            if (!asset.isSynced) {
              vm.assets.push(angular.copy(asset));
            }
          });
        }
        loaderService.showViewLoader = false;
      });
  }

  function _initCriticalityForAssets(assets) {
    if (assets && assets.length > 0) {
      R.forEach(
        (item) => {
          const classMappings = {
            1: 'status-tier-bar--terrible',
            2: 'status-tier-bar--bad',
            3: 'status-tier-bar--caution',
            4: 'status-tier-bar--good',
            5: 'status-tier-bar--great',
          };
          item.criticalityCssClass = classMappings[item.assetCriticalityId];
          item.assetCriticality = assetSharedModelService.AssetCriticalities.find(
            assetCriticality => assetCriticality.assetCriticalityId === item.assetCriticalityId
          );
        },
        assets
      );
    }
  }
}

SyncAssetTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'ssDialogService',
  'confirmDialog',
  'alerts',
  'assetDataService',
  'loaderService',
  'syncAssetConfirmDialog',
  'assetSharedModelService'
];
